import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Media from 'components/common/Media'
import HTMLContainer from 'components/common/HTMLContainer/HTMLContainer'
import { A } from 'components/common/Link/Link'
import Portal from 'components/common/Portal/Portal'
import ClientRendering from 'components/common/ClientRendering/ClientRendering'
import toggle from 'components/common/hoc/toggle'
import { getCleanText, truncate } from './helpers'
import { TRIGGER_CONTAINER_ID } from './constants'

const ReadMoreExpander = ({
  expanded,
  toggleHandlers,
  content = '',
  enableShowLess,
  enableReadMore = true,
  target = '_self',
  href = '#',
  limit,
  uid = '0'
}) => {
  const attr = {}
  if (href === '#') {
    attr.prevent = true
    attr.handler = toggleHandlers.onClick
  }
  const showMoreLink = (!expanded || !!enableShowLess) && enableReadMore && getCleanText(content).length > limit
  const TriggerID = TRIGGER_CONTAINER_ID + uid
  return (
    <ClientRendering>
      <HTMLContainer
        inline
        content={
          !expanded && getCleanText(content).length > limit ?
            truncate(content, limit, `...<span id="${TriggerID}"></span>`) : `${content}`
        } />
      {
        showMoreLink &&
        <Portal id={ TriggerID } inline>
          &nbsp;&nbsp;<A
            data-at-read-more
            bolder
            href={ href }
            target={ target }
            { ...attr } >
            Read { expanded ? 'Less' : 'More' }</A>
        </Portal>
      }
    </ClientRendering>
  )
}

const StaticPreview = ({ content }) =>
  <HTMLContainer inline content={ content } />

const ReadMore = ({ mobile, ...props }) =>
  <ClientRendering>
    {
      mobile ?
        <Fragment>
          <Media.Desktop>
            <StaticPreview { ...props } />
          </Media.Desktop>
          <Media.Mobile>
            <ReadMoreExpander { ...props } />
          </Media.Mobile>
        </Fragment> :
        <ReadMoreExpander { ...props } />
    }
  </ClientRendering>

ReadMore.propTypes = {
  mobile: PropTypes.bool
}

ReadMoreExpander.propTypes = {
  content: PropTypes.string,
  enableReadMore: PropTypes.bool,
  enableShowLess: PropTypes.bool,
  expanded: PropTypes.bool,
  href: PropTypes.string,
  limit: PropTypes.number,
  target: PropTypes.string,
  toggleHandlers: PropTypes.shape({
    onClick: PropTypes.func
  }),
  uid: PropTypes.string
}

StaticPreview.propTypes = {
  content: PropTypes.string
}

export default toggle(ReadMore)
